// extracted by mini-css-extract-plugin
export default {"trimRow":"TrimSelector_trimRow__o47u3","trimPrice":"TrimSelector_trimPrice__6+eSq","emptyMsg":"TrimSelector_emptyMsg__hIJx0"};